/**
 *对导航的操作都写在这个文件里
 */
import 'jquery'
import 'common'
import 'sass/layout.scss'
import '../api/api'
import { loadHeader, render } from "../api/render";

{

    const event = () => {
        // open||close
        $(".phone_headerBox").on('click', '.menuContent', function () {
            $(this).toggleClass('open_icon');
            $(".phone_menu").toggleClass('open_menu');
        })

        //phone
        $(".phone_headerBox .phone_menu").on('click', 'li p', function () {
            if ($(this).parent('li').hasClass('active')) {
                $(this).next('div').slideUp();
                $(this).parent('li').removeClass('active');
            } else {
                $(".phone_menu li").find('div').slideUp();
                $(".phone_menu li").removeClass('active');
                $(this).next('div').slideDown();
                $(this).parent('li').addClass('active');
            }

        })


        //页面标记
        let page_index = $("html").attr('data-page');
        $(".pc_headerBox div[data-page='" + page_index + "']").addClass('page_active');
        $(".phone_menu li[data-page='" + page_index + "']").addClass('page_active');
        switch (page_index) {
            case '2':
                let $id = window.location.search.split('=')[1];
                if ($id) {
                    $("#pc_menu li[data-typeId='" + $id + "']").addClass('type_active');
                } else {
                    $("#pc_menu li:eq(0)").addClass('type_active');
                }
                break;
            case '3':
                let about_index = $("html").attr('data-about');
                $(".pc_headerBox li[data-about='" + about_index + "']").addClass('type_active');
                break;
            case '4':
                let brand_index = $("html").attr('data-brand');
                $(".pc_headerBox li[data-brand='" + brand_index + "']").addClass('type_active');
                break;
        }


        const inputElement = document.getElementById('pc_search');
        const buttonElement = document.getElementById('search_btn');
        function performSearch() {
            let keyword = inputElement.value.trim();
            if (keyword === '') {
                return;
            }
            if (sessionStorage.getItem('Language') == 'EN') {
                window.location.href = 'search.html?keyword=' + keyword;
            } else {
                window.location.href = 'search_cn.html?keyword=' + keyword;
            }

        }

        // 1. 点击搜索按钮触发
        buttonElement.addEventListener('click', performSearch);

        // 2. 按回车键触发
        inputElement.addEventListener('keypress', function (event) {
            // 检测 Enter 键（key = 'Enter' 或 code = 'Enter'）
            if (event.key === 'Enter') {
                event.preventDefault();  // 避免某些浏览器下的意外刷新或提交
                performSearch();
            }
        });

    }

    const getMenu = () => {
        new Promise(resolve => {
            api.getSubmenu(385).then(res => {
                let link = { list: res.data };
                render('pc_menuTmp', 'pc_menu', link);
                render('phone_menuTmp', 'phone_menu', link);
                event();
            })
        })
    }


    //中英文
    const switchLanguage = () => {
        var pageUrl = window.location.href;
        var cnUrl = pageUrl.replace('.html', "_cn.html");
        var enUrl = pageUrl.replace('_cn.', ".");

        if ($('html').attr("data-page") == '1') {
        } else {
            if (sessionStorage.getItem('Language') == 'EN') {
                console.log(cnUrl);
                $(".page_cn").attr("href", cnUrl);
                $(".page_en").attr("href", pageUrl);
            } else {
                $(".page_cn").attr("href", pageUrl);
                $(".page_en").attr("href", enUrl);
            }
        }

        $('.page_en').on('click', function () {
            window.sessionStorage.setItem("Language", 'EN');
            window.location.reload();
        })
        $('.page_cn').on('click', function () {
            window.sessionStorage.setItem("Language", 'CN');
        })
    }


    /**
     * 将异步渲染代码和回调按顺序结合到一起，顺序很重要！！！先做什么再做什么很重要！！！
     */
    (async () => {
        let yuyan = sessionStorage.getItem('Language');
        if (yuyan == 'EN') {
            await loadHeader("#g-header", "./default/header/header.html");
        } else {
            await loadHeader("#g-header", "./default/header/header_cn.html");
        }
        getMenu();
        switchLanguage();
    })();
}



// WEBPACK FOOTER //
// ./src/entry/Header.js